import { AssistantsProviderServices } from '../providers/assistants/AssistantsProviderServices';
import { IAssistantsProviderServices } from '../providers/assistants/interfaces/IAssistantsProviderServices';
import { NexusProviderServices } from '../providers/nexus/NexusProviderServices';
import { INexusProviderServices } from '../providers/nexus/interfaces/INexusProviderServices';
import { ProGPTProviderServices } from '../providers/progpt/ProGPTProviderServices';
import { IProGPTProviderServices } from '../providers/progpt/interfaces/IProGPTProviderServices';
import { ProviderServicesRouter } from './router/ProviderServicesRouter';
import { getPlaywrightTestSetup } from '../../features/utils/PlaywrightTestSetup';


export interface ProviderServices {
    providerServicesRouter: ProviderServicesRouter;
    assistants: IAssistantsProviderServices;
    nexus: INexusProviderServices;
    proGPT: IProGPTProviderServices;
}

export const createProviderServices = (): ProviderServices => {
    const playwrightProviderServices = getPlaywrightTestSetup()?.createProviderServices;
    if (playwrightProviderServices) {
        return playwrightProviderServices();
    }

    const proGPTBaseUrl = process.env.REACT_APP_PROGPT_BACKEND_URI!;
    const nexusBaseUrl = process.env.REACT_APP_NEXUS_URI!;
    const assistantsBaseUrl = process.env.REACT_APP_ASSISTANTS_URI!;


    const proGPT = new ProGPTProviderServices(proGPTBaseUrl);
    const nexus: INexusProviderServices = new NexusProviderServices(nexusBaseUrl);
    const assistants = new AssistantsProviderServices(assistantsBaseUrl);

    const providerServices = [proGPT, nexus, assistants];

    const providerServicesRouter = new ProviderServicesRouter(providerServices);


    return {
        providerServicesRouter,
        assistants,
        nexus,
        proGPT,
    };
};
